const baseKey = '/v1/trader/dashboard'

export const dashboardTraderApi = {
  getStatistic: baseKey,
}
